module.exports = __webpack_public_path__ + "img/infinity.37d9a9c0.gif";